import { render, staticRenderFns } from "./CompetitionLayout.vue?vue&type=template&id=4d913c3c&scoped=true&"
import script from "./CompetitionLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionLayout.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionLayout.vue?vue&type=style&index=0&id=4d913c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d913c3c",
  null
  
)

export default component.exports